import script from "./QuestionAutumnStatusPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuestionAutumnStatusPanel.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__